import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";

const SpinnerView = ({
  children,
  isFetching,
}: {
  children: JSX.Element;
  isFetching: Boolean;
}) => {
  return (
    <Spin
      spinning={isFetching as boolean}
      indicator={<LoadingOutlined style={{ fontSize: 34 }} />}
    >
      {children}
    </Spin>
  );
};

export default SpinnerView;
